import { requestHandler, requestUpdate, } from '@hatsy/hatsy/core.js';
import { routeMatch, } from '@hatsy/route-match';
import { isIterable, lazyValue } from '@proc7ts/primitives';
/**
 * @internal
 */
function defaultRouteTailExtractor({ route, routeMatch, }) {
    let fromEntry;
    routeMatch((_type, _name, _arg, position) => {
        if (fromEntry == null) {
            fromEntry = position.entryIndex;
        }
    });
    return fromEntry ? route.section(fromEntry) : route;
}
/**
 * @internal
 */
function handlerByDispatchPattern(pattern) {
    const { on } = pattern;
    const tail = pattern.tail ? pattern.tail.bind(pattern) : defaultRouteTailExtractor;
    return async (context) => {
        const { route, routeMatch: prevMatch, routePattern, next } = context;
        const patternMatch = routeMatch(route, typeof on === 'string' ? routePattern(on) : on);
        if (!patternMatch) {
            return;
        }
        const getTail = lazyValue(() => tail({ ...context, routeMatch: patternMatch }));
        await next(pattern.to.bind(pattern), requestUpdate({
            get route() {
                return getTail();
            },
            routeMatch(captor) {
                prevMatch(captor);
                patternMatch(captor);
            },
        }));
    };
}
/**
 * Dispatches request processing by matching route pattern.
 *
 * Builds a route processing handler that dispatcher to route handler(s) corresponding to pattern the route matches.
 *
 * Selects the first matching pattern and delegates request processing to its handler. If the handler not responded,
 * then tries the next matching pattern, and so on until responded or no routes left.
 *
 * @typeParam TRoute - A type of supported route.
 * @typeParam TMeans - A type of route processing means.
 * @param routes - Either a routing dispatch pattern, or iterable of routing dispatch patterns.
 *
 * @returns Route processing handler.
 */
export function dispatchByPattern(routes) {
    return isIterable(routes)
        ? requestHandler(Array.from(routes, handlerByDispatchPattern))
        : handlerByDispatchPattern(routes);
}
//# sourceMappingURL=dispatch-by-pattern.handler.js.map